module.exports = __webpack_public_path__ + "img/win-text.b18a815f.png";